import React from "react";

const Style = ({ attributes }) => {
  const { uniqueId, rowGap, columnGap, videos } = attributes;

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
    #${uniqueId} .timeline {
        column-gap: ${columnGap};
    }
    #${uniqueId} .timeline .videoBox {
        margin-bottom: ${rowGap}
    }
    ${videos
      .map((video, index) => {
        return `#${uniqueId} .timeline.video${index + 1} .videoBox #timelinePlayer {
            border-radius: ${video.borderRadius};
            border-width: ${video.border?.width};
            border-style: ${video.border?.style};
            border-color: ${video.border?.color};
        }`;
      })
      .join("")}
  `,
      }}
    ></style>
  );
};

export default Style;
